import React from 'react';
import { isLoggedIn } from '../../authentication/cognito';
import { PageEvent } from '../../app-page-events';
import PlaidApp from '../../plaid/plaid-app';

import './home.scss';

export default class HomePage extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
          userId: props.userId
      };
  }

  componentDidMount() {
    if (!isLoggedIn())
      return this.props.onPageUpdateEvent(PageEvent.APP_LOGOUT);
  }

  render() {
    const { userId } = this.state;
    
    return (
      <React.Fragment>
        <PlaidApp userId={userId} />
      </React.Fragment>
    )
  }
};